const UsersServiceInterface = require('@tradetrax/users-service-interface');
const ServiceClient = require('@tradetrax/service-client');
const { serviceUrl } = require('@tradetrax/web-common');

export const usersService = ServiceClient(serviceUrl('users'), UsersServiceInterface);
